module.exports = __webpack_public_path__ + "static/media/providers-empty-state-d.7e3407d1.svg";